var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 1.4V0.7C8.4 0.3136 8.7136 0 9.1 0C9.4864 0 9.8 0.3136 9.8 0.7V1.4C11.3463 1.4 12.6 2.6537 12.6 4.2V11.2C12.6 12.7463 11.3463 14 9.8 14C7.798 14 4.8013 14 2.8 14C1.2537 14 0 12.7463 0 11.2V4.2C0 2.6537 1.2537 1.4 2.8 1.4V0.7C2.8 0.3136 3.1136 0 3.5 0C3.8864 0 4.2 0.3136 4.2 0.7V1.4H8.4ZM11.2 7H1.4V11.2C1.4 11.9728 2.0265 12.6 2.8 12.6H9.8C10.5728 12.6 11.2 11.9728 11.2 11.2V7ZM9.8 2.8V3.5C9.8 3.8864 9.4864 4.2 9.1 4.2C8.7136 4.2 8.4 3.8864 8.4 3.5V2.8H4.2V3.5C4.2 3.8864 3.8864 4.2 3.5 4.2C3.1136 4.2 2.8 3.8864 2.8 3.5V2.8C2.0265 2.8 1.4 3.4265 1.4 4.2V5.6H11.2V4.2C11.2 3.4265 10.5728 2.8 9.8 2.8Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.3cebdb7e84b224741b2089be8320e28f.svg";
export { ForwardRef as ReactComponent };